function getType(user) {
    if (user.is_admin) {
        return ' (Admin)';
    }

    if (user.contractor_id || user.crew_id) {
        return ' (Provider)';
    }

    return ' (Customer)';
}

// eslint-disable-next-line import/prefer-default-export
export function fullName({ user, withType = false }) {
    if (!user.last_name) {
        return `${user.first_name}${withType ? getType(user) : ''}`;
    }

    return `${user.first_name} ${user.last_name}${withType ? getType(user) : ''}`;
}
